import { map } from "rxjs/operators";
import { Injectable, inject } from "@angular/core";

import { Observable } from "rxjs";

import { environment } from "environments/environment";
import { FclQuoteLocationSurcharge } from "./models/quote-location-surcharge-fcl.model";
import { LclQuoteLocationSurcharge } from "./models/quote-location-surcharge-lcl.model";
import { QuoteLocationSurcharge } from "./quote-location-surcharge.type";
import { QuoteLocationSurchargeMapper } from "./quote-location-surcharge.mapper";
import { LocationSurcharge } from "../../location/location-surcharge/location-surcharge.type";
import { HttpClient } from "@angular/common/http";
import { lclFormFields } from "../../shared/form/fields/lcl-form-fields.const";
import { AirQuoteLocationSurcharge } from "./models/quote-location-surcharge-air.model";
import { BrokerageQuote } from "../models/quote-brokerage.model";

@Injectable()
export class QuoteLocationSurchargeRepository {
  private http = inject(HttpClient);

  public add(
    quoteId: number,
    discriminator: string,
    locationSurchargeId: number,
    quoteLocationSurcharge: QuoteLocationSurcharge,
  ): Observable<QuoteLocationSurcharge> {
    let payload = quoteLocationSurcharge
      ? {
          locationSurcharge: locationSurchargeId,
          name: quoteLocationSurcharge.getName(),
          internalNote: quoteLocationSurcharge.getInternalNote(),
        }
      : { locationSurcharge: locationSurchargeId };

    if (quoteLocationSurcharge) {
      payload = this.extendPayloadByContainerLoad(
        payload,
        quoteLocationSurcharge,
      );
    }

    return this.http
      .post(
        `${environment.apiUrl}/quote/${quoteId}/quotelocationsurcharge`,
        payload,
      )
      .pipe(map((response) => QuoteLocationSurchargeMapper.map(response)));
  }

  public delete(surcharge: LocationSurcharge): Observable<object> {
    return this.http.delete(
      `${environment.apiUrl}/quotelocationsurcharge/${surcharge
        .getQuoteLocationSurcharges()[0]
        .getId()}`,
    );
  }

  public save(
    quoteLocationSurcharge: QuoteLocationSurcharge,
  ): Observable<QuoteLocationSurcharge> {
    let payload = {
      name: quoteLocationSurcharge.getName(),
      internalNote: quoteLocationSurcharge.getInternalNote(),
    };

    payload = this.extendPayloadByContainerLoad(
      payload,
      quoteLocationSurcharge,
    );

    return this.http
      .patch(
        `${
          environment.apiUrl
        }/quotelocationsurcharge/${quoteLocationSurcharge.getId()}`,
        payload,
      )
      .pipe(map((json) => QuoteLocationSurchargeMapper.map(json)));
  }

  public reorder(movedId: number, position?: number): Observable<object> {
    return this.http
      .patch(
        `${environment.apiUrl}/quotelocationsurcharge/${movedId}/reorder`,
        { position },
      )
      .pipe(map((response) => response));
  }

  private extendPayloadByContainerLoad(
    payload: any,
    surcharge: QuoteLocationSurcharge,
  ) {
    if (
      surcharge instanceof FclQuoteLocationSurcharge &&
      !(surcharge.getQuote() instanceof BrokerageQuote)
    ) {
      payload["containers"] = surcharge.getContainers().getRequestParams();
      payload[lclFormFields.SHIPMENT_PRICE] = surcharge.getShipmentPrice();
    }

    if (
      surcharge instanceof FclQuoteLocationSurcharge &&
      surcharge.getQuote() instanceof BrokerageQuote
    ) {
      payload[lclFormFields.SHIPMENT_PRICE] = surcharge.getShipmentPrice();
      payload[lclFormFields.SHIPMENT_DISPLAY_UNIT_NAME] =
        surcharge.shipmentDisplayUnitName;
    }

    if (surcharge instanceof AirQuoteLocationSurcharge) {
      payload[lclFormFields.CHARGEABLE_WEIGHT_PRICE] =
        surcharge.getChargeableWeightPrice();
    }

    if (
      surcharge instanceof LclQuoteLocationSurcharge ||
      surcharge instanceof AirQuoteLocationSurcharge
    ) {
      payload[lclFormFields.WEIGHT_PRICE] = surcharge.getWeightPrice();
      payload[lclFormFields.MEASUREMENT_PRICE] =
        surcharge.getMeasurementPrice();
      payload[lclFormFields.SHIPMENT_PRICE] = surcharge.getShipmentPrice();
      payload[lclFormFields.PIECE_PRICE] = surcharge.getPiecePrice();
      payload[lclFormFields.DOCUMENT_PRICE] = surcharge.getDocumentPrice();
    }

    return payload;
  }
}
